import type { ComparisonConfig } from './ComparisonPage';

const HOTELOGIX_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-hotelogix',
  competitorName: 'Hotelogix',
  heroTitle: 'HotelStack.io बनाम Hotelogix',
  heroSubtitle: 'दो अग्रणी होटल प्रबंधन प्लेटफार्मों की व्यापक तुलना। देखें कैसे HotelStack.io, Hotelogix से अधिक सुविधाएं, आधुनिक आर्किटेक्चर और बेहतर मूल्य प्रदान करता है।',
  overviewComparison: [
    { label: 'कुल मॉड्यूल', hotelstack: '36 एकीकृत मॉड्यूल', competitor: '15 मॉड्यूल' },
    { label: 'आर्किटेक्चर', hotelstack: 'क्लाउड-नेटिव SaaS', competitor: 'लेगेसी क्लाउड' },
    { label: 'वैश्विक पहुंच', hotelstack: '40+ देश', competitor: 'मुख्य रूप से एशिया' },
    { label: 'चैनल मैनेजर', hotelstack: 'बिल्ट-इन (100+ OTA)', competitor: 'ऐड-ऑन आवश्यक' },
    { label: 'बुकिंग इंजन', hotelstack: 'BookMyRoom.io (निःशुल्क)', competitor: 'बुनियादी विजेट' },
    { label: 'सहायता', hotelstack: '24/7 समर्पित', competitor: 'ईमेल + चैट' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'ड्रैग-एंड-ड्रॉप चेक-इन', hotelstack: true, competitor: false },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'गेस्ट फोलियो प्रबंधन', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: false },
        { name: 'वॉक-इन बुकिंग मोडल', hotelstack: true, competitor: 'सीमित' },
      ],
    },
    {
      category: 'राजस्व प्रबंधन',
      features: [
        { name: 'डायनामिक प्राइसिंग नियम', hotelstack: true, competitor: false },
        { name: 'व्हाट-इफ रेवेन्यू सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: false },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: false },
        { name: 'RevPAR एनालिटिक्स', hotelstack: true, competitor: 'बुनियादी' },
      ],
    },
    {
      category: 'अतिथि प्रबंधन',
      features: [
        { name: '360-डिग्री अतिथि प्रोफाइल', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'लॉयल्टी प्रोग्राम प्रबंधन', hotelstack: true, competitor: false },
        { name: 'अतिथि संचार ऑटोमेशन', hotelstack: true, competitor: 'सीमित' },
        { name: 'अतिथि खर्च एनालिटिक्स', hotelstack: true, competitor: false },
        { name: 'आईडी अपलोड और फोटो कैप्चर', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'खाद्य एवं पेय और POS',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: false },
        { name: 'टेबल फ्लोर प्लान', hotelstack: true, competitor: false },
        { name: 'किचन डिस्प्ले सिस्टम', hotelstack: true, competitor: false },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'रिपोर्टिंग और एनालिटिक्स',
      features: [
        { name: 'फ्लैश रिपोर्ट', hotelstack: true, competitor: true },
        { name: 'लाभ-हानि विवरण', hotelstack: true, competitor: false },
        { name: 'पेस रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'कर अनुपालन रिपोर्ट', hotelstack: true, competitor: 'बुनियादी' },
        { name: 'कस्टम रिपोर्ट बिल्डर', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'मल्टी-प्रॉपर्टी',
      features: [
        { name: 'चेन डैशबोर्ड', hotelstack: true, competitor: true },
        { name: 'क्रॉस-प्रॉपर्टी एनालिटिक्स', hotelstack: true, competitor: false },
        { name: 'केंद्रीकृत दर प्रबंधन', hotelstack: true, competitor: false },
        { name: 'ब्रांड सेटिंग्स', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: false },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$60+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। कोई सुविधा प्रतिबंध नहीं। निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य निर्धारण।',
    competitorNote: 'सीमित मॉड्यूल के साथ बेसिक प्लान। चैनल मैनेजर और उन्नत सुविधाओं के लिए अतिरिक्त शुल्क।',
  },
  advantages: [
    'दोगुने से अधिक मॉड्यूल (36 बनाम 15) बिना किसी अतिरिक्त शुल्क के',
    '2024 में निर्मित आधुनिक क्लाउड-नेटिव आर्किटेक्चर, सभी उपकरणों पर रीयल-टाइम सिंक',
    '6 मुद्राओं में क्षेत्रीय मूल्य निर्धारण और 40+ देशों के लिए अनुपालन उपकरण',
    'BookMyRoom.io के माध्यम से बिल्ट-इन बुकिंग इंजन — कमीशन-मुक्त सीधी बुकिंग शामिल',
    'डायनामिक प्राइसिंग, मांग पूर्वानुमान और व्हाट-इफ सिम्युलेटर के साथ उन्नत राजस्व प्रबंधन',
    'टेबल प्रबंधन, किचन डिस्प्ले और रूम सर्विस के साथ पूर्ण खाद्य एवं पेय और POS मॉड्यूल',
    'बेस प्लान में अधिक सुविधाओं के साथ कम शुरुआती कीमत',
    'समर्पित ऑनबोर्डिंग सहायता के साथ Hotelogix से निःशुल्क डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'HotelStack.io उन होटलों के लिए मजबूत विकल्प है जो एक आधुनिक, ऑल-इन-वन प्लेटफॉर्म चाहते हैं। 36 मॉड्यूल, बिल्ट-इन राजस्व प्रबंधन, खाद्य एवं पेय क्षमताओं और कम कीमतों के साथ, यह Hotelogix से काफी अधिक मूल्य प्रदान करता है। Hotelogix उन बजट होटलों के लिए उपयुक्त हो सकता है जिन्हें केवल बुनियादी PMS कार्यक्षमता की आवश्यकता है।',
    bestFor: [
      'बिना अतिरिक्त शुल्क के आधुनिक ऑल-इन-वन प्लेटफॉर्म चाहने वाले होटल',
      'उन्नत राजस्व प्रबंधन और डायनामिक प्राइसिंग की आवश्यकता वाली संपत्तियां',
      'खाद्य एवं पेय, POS और रूम सर्विस क्षमताओं की आवश्यकता वाले होटल',
      'क्षेत्रीय अनुपालन और बहु-मुद्रा बिलिंग की आवश्यकता वाली संपत्तियां',
      'केंद्रीकृत एनालिटिक्स और दर प्रबंधन की आवश्यकता वाली मल्टी-प्रॉपर्टी चेन',
    ],
  },
  faqItems: [
    { question: 'क्या मैं Hotelogix से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी टीम अतिथि प्रोफाइल, आरक्षण इतिहास, दर योजनाओं और कमरे के कॉन्फिगरेशन सहित Hotelogix से पूर्ण डेटा माइग्रेशन संभालती है। माइग्रेशन निःशुल्क है और आमतौर पर शून्य डाउनटाइम के साथ 48 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io में Hotelogix की सभी सुविधाएं हैं?', answer: 'HotelStack.io में Hotelogix की हर सुविधा शामिल है साथ ही 17 अतिरिक्त मॉड्यूल जिनमें राजस्व प्रबंधन, खाद्य एवं पेय/POS, लॉयल्टी प्रोग्राम, अनुपालन उपकरण और उन्नत एनालिटिक्स शामिल हैं जो Hotelogix प्रदान नहीं करता।' },
    { question: 'HotelStack.io और Hotelogix के बीच कीमतों की तुलना कैसे है?', answer: 'HotelStack.io $49/माह से शुरू होता है जिसमें सभी 36 मॉड्यूल शामिल हैं। EUR, GBP, AED, INR और THB में क्षेत्रीय मूल्य उपलब्ध है। Hotelogix अपने बेस प्लान के लिए लगभग $60+/माह से शुरू होता है, चैनल मैनेजर और अन्य सुविधाओं के लिए अतिरिक्त शुल्क।' },
    { question: 'क्या HotelStack.io वर्तमान में Hotelogix उपयोग करने वाले छोटे होटलों के लिए उपयुक्त है?', answer: 'बिल्कुल। हमारा स्टार्टर प्लान 50 कमरों तक की संपत्तियों के लिए डिज़ाइन किया गया है जिसमें सभी सुविधाएं अनलॉक हैं। कई छोटे होटल अतिरिक्त मॉड्यूल और कम कीमत के लिए Hotelogix से स्विच करते हैं।' },
  ],
};

const CLOUDBEDS_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-cloudbeds',
  competitorName: 'Cloudbeds',
  heroTitle: 'HotelStack.io बनाम Cloudbeds',
  heroSubtitle: 'दोनों क्लाउड-नेटिव प्लेटफॉर्म हैं। HotelStack.io अधिक मॉड्यूल, कम कीमत और पूर्ण खाद्य एवं पेय/POS क्षमताएं प्रदान करता है जो Cloudbeds में नहीं हैं — सभी बहु-मुद्रा क्षेत्रीय मूल्य निर्धारण के साथ।',
  overviewComparison: [
    { label: 'कुल मॉड्यूल', hotelstack: '36 मॉड्यूल', competitor: '20+ मॉड्यूल' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$100+/माह से' },
    { label: 'क्षेत्रीय मूल्य', hotelstack: '6 मुद्राएं', competitor: 'केवल USD' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'उपलब्ध नहीं' },
    { label: 'बुकिंग इंजन', hotelstack: 'BookMyRoom.io (निःशुल्क)', competitor: 'बुनियादी विजेट' },
    { label: 'ऑनबोर्डिंग', hotelstack: 'निःशुल्क + समर्पित', competitor: 'सेल्फ-सर्विस' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'विज़ुअल रूम बोर्ड', hotelstack: true, competitor: true },
        { name: 'आरक्षण प्रबंधन', hotelstack: true, competitor: true },
        { name: 'ग्रुप बुकिंग', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट विज़ार्ड', hotelstack: true, competitor: true },
        { name: 'ऑनलाइन चेक-इन पोर्टल', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'क्षेत्रीय अनुपालन',
      features: [
        { name: 'बहु-मुद्रा बिलिंग', hotelstack: true, competitor: 'सीमित' },
        { name: 'क्षेत्रीय कर ऑटोमेशन', hotelstack: true, competitor: false },
        { name: 'अतिथि पंजीकरण अनुपालन', hotelstack: true, competitor: false },
        { name: 'GDPR डेटा सुरक्षा', hotelstack: true, competitor: true },
        { name: 'क्षेत्रीय भुगतान गेटवे', hotelstack: true, competitor: 'सीमित' },
        { name: 'स्थानीयकृत इनवॉइसिंग', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'राजस्व प्रबंधन',
      features: [
        { name: 'डायनामिक प्राइसिंग', hotelstack: true, competitor: true },
        { name: 'राजस्व एनालिटिक्स', hotelstack: true, competitor: true },
        { name: 'प्रतिस्पर्धी दर मॉनिटर', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'व्हाट-इफ सिम्युलेटर', hotelstack: true, competitor: false },
        { name: 'मांग पूर्वानुमान', hotelstack: true, competitor: 'बुनियादी' },
      ],
    },
    {
      category: 'खाद्य एवं पेय और संचालन',
      features: [
        { name: 'POS टर्मिनल', hotelstack: true, competitor: false },
        { name: 'रूम सर्विस मॉड्यूल', hotelstack: true, competitor: false },
        { name: 'हाउसकीपिंग बोर्ड', hotelstack: true, competitor: true },
        { name: 'रखरखाव कार्य आदेश', hotelstack: true, competitor: false },
        { name: 'स्टाफ शेड्यूलिंग', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'अनुपालन और रिपोर्टिंग',
      features: [
        { name: 'क्षेत्रीय कर रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'ऑडिट ट्रेल', hotelstack: true, competitor: true },
        { name: 'लाभ-हानि विवरण', hotelstack: true, competitor: 'सीमित' },
        { name: 'कस्टम रिपोर्ट बिल्डर', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: false },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: 'सीमित' },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: false },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। EUR, GBP, AED, INR, THB में क्षेत्रीय मूल्य। निःशुल्क ऑनबोर्डिंग और माइग्रेशन।',
    competitorNote: 'केवल USD मूल्य निर्धारण ($100+/माह)। प्रीमियम सुविधाओं और एकीकरण के लिए अतिरिक्त शुल्क।',
  },
  advantages: [
    'लगभग आधी कीमत पर सभी 36 मॉड्यूल शामिल — मूल सुविधाओं के लिए कोई अतिरिक्त शुल्क नहीं',
    '6 मुद्राओं में क्षेत्रीय मूल्य निर्धारण — अंतरराष्ट्रीय संपत्तियों के लिए विनिमय दर की कोई चिंता नहीं',
    'POS टर्मिनल, रूम सर्विस और किचन प्रबंधन के साथ पूर्ण खाद्य एवं पेय मॉड्यूल',
    'कर ऑटोमेशन, अतिथि पंजीकरण और GDPR के लिए क्षेत्रीय अनुपालन उपकरण',
    'PaymentHooks.com (Stripe, PayPal, 50+ गेटवे) के माध्यम से मल्टी-गेटवे भुगतान सहायता',
    'पेरोल, उपस्थिति और शिफ्ट शेड्यूलिंग के साथ स्टाफ प्रबंधन मॉड्यूल',
    'एसेट ट्रैकिंग के साथ रखरखाव और कार्य आदेश प्रबंधन',
    'समर्पित सहायता टीम के साथ निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'HotelStack.io Cloudbeds की लगभग आधी कीमत पर अधिक मॉड्यूल, बेहतर मूल्य और पूर्ण संचालन उपकरण प्रदान करता है। जबकि Cloudbeds बुनियादी PMS और चैनल प्रबंधन के लिए एक ठोस प्लेटफॉर्म है, HotelStack.io खाद्य एवं पेय/POS, स्टाफ प्रबंधन, रखरखाव और उन्नत राजस्व उपकरण जोड़ता है — सभी बेस कीमत में शामिल।',
    bestFor: [
      'कम कीमत पर पूर्ण ऑल-इन-वन प्लेटफॉर्म चाहने वाले होटल',
      'एक सिस्टम में खाद्य एवं पेय, POS और स्टाफ प्रबंधन की आवश्यकता वाली संपत्तियां',
      'क्षेत्रीय अनुपालन और बहु-मुद्रा बिलिंग चाहने वाले होटल',
      'सेल्फ-सर्विस सेटअप की जगह समर्पित ऑनबोर्डिंग पसंद करने वाली संपत्तियां',
      'केंद्रीकृत एनालिटिक्स और दर प्रबंधन की आवश्यकता वाली मल्टी-प्रॉपर्टी चेन',
    ],
  },
  faqItems: [
    { question: 'क्या मैं Cloudbeds से HotelStack.io पर माइग्रेट कर सकता हूं?', answer: 'हां। हमारी ऑनबोर्डिंग टीम अतिथि प्रोफाइल, आरक्षण इतिहास और दर योजनाओं सहित Cloudbeds से पूर्ण डेटा माइग्रेशन संभालती है। माइग्रेशन निःशुल्क है और आमतौर पर 48 घंटों में पूरा होता है।' },
    { question: 'क्या HotelStack.io Cloudbeds के समान OTA चैनल सपोर्ट करता है?', answer: 'हां। HotelStack.io Booking.com, Expedia, Airbnb, Agoda और क्षेत्रीय प्लेटफार्मों सहित 100+ OTA से जुड़ता है। Amadeus और Sabre के माध्यम से GDS कनेक्टिविटी भी समर्थित है।' },
    { question: 'HotelStack.io, Cloudbeds से अधिक किफायती क्यों है?', answer: 'HotelStack.io हर प्लान में सभी 36 मॉड्यूल शामिल करता है बिना अतिरिक्त शुल्क के। 6 मुद्राओं में क्षेत्रीय मूल्य निर्धारण लागत को और कम करता है। Cloudbeds प्रीमियम सुविधाओं के लिए अतिरिक्त शुल्क लेता है और केवल USD मूल्य प्रदान करता है।' },
    { question: 'क्या HotelStack.io अंतरराष्ट्रीय संपत्तियों के लिए काम करता है?', answer: 'बिल्कुल। HotelStack.io बहु-मुद्रा बिलिंग, क्षेत्रीय कर अनुपालन और अंतरराष्ट्रीय भुगतान गेटवे का समर्थन करता है। 40+ देशों के होटल अपने संचालन के प्रबंधन के लिए HotelStack.io का उपयोग करते हैं।' },
  ],
};

const MEWS_HI: ComparisonConfig = {
  slug: 'hotelstack-vs-mews',
  competitorName: 'Mews',
  heroTitle: 'HotelStack.io बनाम Mews',
  heroSubtitle: 'Mews प्रीमियम मूल्य निर्धारण और सशुल्क कार्यान्वयन के साथ एंटरप्राइज़ होटलों को लक्षित करता है। HotelStack.io लागत के एक अंश पर अधिक मॉड्यूल के साथ वही आधुनिक अनुभव प्रदान करता है — निःशुल्क ऑनबोर्डिंग शामिल।',
  overviewComparison: [
    { label: 'होटल सेगमेंट', hotelstack: 'SMB से एंटरप्राइज़', competitor: 'केवल एंटरप्राइज़' },
    { label: 'मूल्य निर्धारण', hotelstack: '$49/माह से', competitor: '$200+/माह' },
    { label: 'कुल मॉड्यूल', hotelstack: '36 बिल्ट-इन', competitor: '15+ कोर' },
    { label: 'खाद्य एवं पेय / POS', hotelstack: 'बिल्ट-इन', competitor: 'एकीकरण द्वारा' },
    { label: 'UI/UX गुणवत्ता', hotelstack: 'मॉडर्न डार्क लक्ज़री', competitor: 'मॉडर्न मिनिमल' },
    { label: 'ऑनबोर्डिंग', hotelstack: 'निःशुल्क + समर्पित', competitor: 'सशुल्क कार्यान्वयन' },
  ],
  featureTable: [
    {
      category: 'कोर PMS',
      features: [
        { name: 'क्लाउड-नेटिव आर्किटेक्चर', hotelstack: true, competitor: true },
        { name: 'आधुनिक UI/UX', hotelstack: true, competitor: true },
        { name: 'रीयल-टाइम सिंक', hotelstack: true, competitor: true },
        { name: 'मल्टी-डिवाइस एक्सेस', hotelstack: true, competitor: true },
        { name: 'नाइट ऑडिट ऑटोमेशन', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'क्षेत्रीय अनुपालन',
      features: [
        { name: 'बहु-मुद्रा बिलिंग', hotelstack: true, competitor: true },
        { name: 'क्षेत्रीय कर ऑटोमेशन', hotelstack: true, competitor: 'केवल EU' },
        { name: 'अतिथि पंजीकरण अनुपालन', hotelstack: true, competitor: 'केवल EU' },
        { name: 'GDPR डेटा सुरक्षा', hotelstack: true, competitor: true },
        { name: 'क्षेत्रीय भुगतान गेटवे', hotelstack: true, competitor: 'सीमित' },
        { name: 'क्षेत्रीय मूल्य निर्धारण (6 मुद्राएं)', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'राजस्व और वितरण',
      features: [
        { name: 'चैनल मैनेजर', hotelstack: true, competitor: true },
        { name: 'डायनामिक प्राइसिंग', hotelstack: true, competitor: true },
        { name: 'बुकिंग इंजन', hotelstack: true, competitor: true },
        { name: 'राजस्व एनालिटिक्स', hotelstack: true, competitor: true },
        { name: 'व्हाट-इफ सिम्युलेटर', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'संचालन',
      features: [
        { name: 'हाउसकीपिंग प्रबंधन', hotelstack: true, competitor: true },
        { name: 'POS / खाद्य एवं पेय मॉड्यूल', hotelstack: true, competitor: 'एकीकरण द्वारा' },
        { name: 'स्टाफ शेड्यूलिंग', hotelstack: true, competitor: false },
        { name: 'रखरखाव / कार्य आदेश', hotelstack: true, competitor: false },
        { name: 'अतिथि संचार', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'मूल्य निर्धारण और सहायता',
      features: [
        { name: 'निःशुल्क ऑनबोर्डिंग', hotelstack: true, competitor: false },
        { name: 'निःशुल्क डेटा माइग्रेशन', hotelstack: true, competitor: false },
        { name: '24/7 सहायता', hotelstack: true, competitor: 'कार्यालय समय' },
        { name: 'कोई कार्यान्वयन शुल्क नहीं', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'लचीलापन और ऑफ़लाइन',
      features: [
        { name: 'ऑफ़लाइन-सक्षम PWA', hotelstack: true, competitor: false },
        { name: 'ऑफ़लाइन परिवर्तन कतार', hotelstack: true, competitor: false },
        { name: 'पुनः कनेक्ट होने पर बैकग्राउंड सिंक', hotelstack: true, competitor: false },
        { name: 'विरोध-सचेत समाधान', hotelstack: true, competitor: false },
        { name: 'इंस्टॉल करने योग्य फ्रंट डेस्क', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'कॉर्पोरेट और समूह बिक्री',
      features: [
        { name: 'कॉर्पोरेट दर प्रबंधन', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'रूमिंग लिस्ट के साथ समूह बुकिंग', hotelstack: true, competitor: true },
        { name: 'प्राप्य आयु और उत्पादन रिपोर्ट', hotelstack: true, competitor: 'ऐड-ऑन' },
        { name: 'रेस्तरां आरक्षण', hotelstack: true, competitor: 'एकीकरण द्वारा' },
      ],
    },
    {
      category: 'स्टाफ और मानव संसाधन',
      features: [
        { name: 'स्टाफ निर्देशिका और शेड्यूलिंग', hotelstack: true, competitor: 'एकीकरण द्वारा' },
        { name: 'पेरोल प्रोसेसिंग', hotelstack: true, competitor: false },
        { name: 'अवकाश और उपस्थिति', hotelstack: true, competitor: false },
        { name: 'प्रदर्शन विश्लेषण', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$200+',
    hotelstackNote: 'सभी 36 मॉड्यूल शामिल। निःशुल्क ऑनबोर्डिंग और माइग्रेशन। 6 मुद्राओं में क्षेत्रीय मूल्य।',
    competitorNote: 'एंटरप्राइज़ मूल्य ($200+/माह)। सशुल्क कार्यान्वयन और ऑनबोर्डिंग। प्रीमियम सहायता अतिरिक्त।',
  },
  advantages: [
    'हर प्लान में अधिक मॉड्यूल शामिल होने के साथ लगभग 75% कम शुरुआती कीमत',
    'Mews के सशुल्क कार्यान्वयन के मुकाबले निःशुल्क ऑनबोर्डिंग और डेटा माइग्रेशन',
    'Mews में तृतीय-पक्ष एकीकरण की आवश्यकता के मुकाबले पूर्ण बिल्ट-इन खाद्य एवं पेय और POS',
    '6 मुद्राओं में क्षेत्रीय मूल्य निर्धारण — होटल अपनी स्थानीय मुद्रा में भुगतान करें',
    'स्टाफ प्रबंधन, पेरोल और शिफ्ट शेड्यूलिंग शामिल',
    'रखरखाव और कार्य आदेश प्रबंधन प्लेटफॉर्म में बिल्ट-इन',
    'Mews के कार्यालय-समय सहायता के मुकाबले 24/7 समर्पित सहायता',
    'SMB होटलों के लिए भी सुलभ, केवल एंटरप्राइज़ नहीं — सभी प्लान में सभी मॉड्यूल शामिल',
  ],
  verdict: {
    title: 'हमारा निर्णय',
    summary: 'Mews प्रीमियम मूल्य भुगतान करने को तैयार एंटरप्राइज़ होटलों के लिए एक उत्कृष्ट प्लेटफॉर्म है। HotelStack.io आधुनिक UX और क्लाउड आर्किटेक्चर में Mews की बराबरी करता है जबकि खाद्य एवं पेय/POS, स्टाफ प्रबंधन और रखरखाव मॉड्यूल जोड़ता है — सभी लगभग एक चौथाई कीमत पर निःशुल्क ऑनबोर्डिंग के साथ।',
    bestFor: [
      'अधिक सुलभ कीमत पर Mews-गुणवत्ता UX चाहने वाले होटल',
      'बिल्ट-इन खाद्य एवं पेय, POS और संचालन उपकरणों की आवश्यकता वाली संपत्तियां',
      'सशुल्क कार्यान्वयन शुल्क के बिना निःशुल्क ऑनबोर्डिंग चाहने वाले होटल',
      'Mews एंटरप्राइज़ प्लान से बाहर कीमत वाले SMB और मिड-स्केल संपत्तियां',
      'क्षेत्रीय अनुपालन के साथ केंद्रीकृत प्रबंधन की आवश्यकता वाली मल्टी-प्रॉपर्टी चेन',
    ],
  },
  faqItems: [
    { question: 'UI गुणवत्ता के मामले में HotelStack.io, Mews से कैसे तुलना करता है?', answer: 'दोनों प्लेटफॉर्म आधुनिक, सहज इंटरफेस प्रदान करते हैं। HotelStack.io में आतिथ्य उद्योग के लिए विशेष रूप से डिज़ाइन किया गया डार्क लक्ज़री थीम है, जिसमें एक डैशबोर्ड से 36 पूर्ण एकीकृत मॉड्यूल उपलब्ध हैं। Mews में यूरोपीय वर्कफ़्लो पर केंद्रित स्वच्छ न्यूनतम डिज़ाइन है।' },
    { question: 'क्या Mews में खाद्य एवं पेय और POS क्षमताएं शामिल हैं?', answer: 'Mews को खाद्य एवं पेय और POS के लिए तृतीय-पक्ष एकीकरण की आवश्यकता होती है। HotelStack.io में हर प्लान में मानक सुविधाओं के रूप में पूर्ण POS टर्मिनल, रूम सर्विस मॉड्यूल, किचन डिस्प्ले सिस्टम और डाइनिंग प्रबंधन शामिल है।' },
    { question: 'क्या मुझे कम कीमत पर Mews जैसा ही आधुनिक अनुभव मिल सकता है?', answer: 'हां। HotelStack.io रीयल-टाइम सिंक, सुंदर UI और 36 मॉड्यूल के साथ आधुनिक क्लाउड-नेटिव अनुभव $49/माह पर प्रदान करता है बनाम Mews $200+/माह। साथ ही, ऑनबोर्डिंग और माइग्रेशन निःशुल्क है।' },
    { question: 'क्या HotelStack.io, Mews की तरह API एकीकरण प्रदान करता है?', answer: 'हां। HotelStack.io भुगतान गेटवे, OTA, अकाउंटिंग सॉफ्टवेयर और तृतीय-पक्ष सेवाओं के लिए API के साथ एकीकरण मार्केटप्लेस प्रदान करता है। हमारा API-फर्स्ट आर्किटेक्चर एंटरप्राइज़ आवश्यकताओं के लिए कस्टम एकीकरण का समर्थन करता है।' },
  ],
};

export const COMPARISON_HI: Record<string, ComparisonConfig> = {
  'hotelstack-vs-hotelogix': HOTELOGIX_HI,
  'hotelstack-vs-cloudbeds': CLOUDBEDS_HI,
  'hotelstack-vs-mews': MEWS_HI,
};
